import { render, staticRenderFns } from "./GetInsights.vue?vue&type=template&id=70227cae&scoped=true"
import script from "./GetInsights.vue?vue&type=script&lang=js"
export * from "./GetInsights.vue?vue&type=script&lang=js"
import style0 from "./GetInsights.vue?vue&type=style&index=0&id=70227cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_ckru7f3yypsoan6edyu23zfbiq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70227cae",
  null
  
)

export default component.exports